import { NgModule } from '@angular/core';

import { DashboardComponent } from './dashboard.component';

@NgModule({
    imports: [],
    exports: [],
    declarations: [DashboardComponent],
    providers: []
})

export class DashboardModule {

}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.module.ts